import { DetailsList, DetailsListLayoutMode, MessageBar, MessageBarType, ProgressIndicator, SelectionMode, Stack } from "@fluentui/react"
import { useEffect, useMemo } from "react"
import { useApiCall } from "../hooks/apiHooks"
import { useParametersContext } from "../providers/parametersProvider"
import { IReportConfiguration } from "./reports"

interface IReportProps {
	reportConfiguration: IReportConfiguration
}

export function Report(props: IReportProps): JSX.Element {
	const reportParams = useParametersContext()
	const body = useMemo(
		() => ({
			Parameters: reportParams.Results
		}),
		[reportParams.Results]
	)

	const {
		data: report = [],
		fetchData: getReport,
		loading,
		error
	} = useApiCall<any[]>(`getReport?reportConfigurationId=${props.reportConfiguration.cw_reportconfigurationid}`, {
		crm: false,
		method: "POST",
		body: JSON.stringify(body),
		canFetch: reportParams.AllParametersComplete
	})

	useEffect(() => {
		if (reportParams.AllParametersComplete) {
			getReport()
		}
	}, [reportParams.AllParametersComplete, reportParams.Results])

	return (
		<Stack tokens={{ childrenGap: 10 }}>
			{reportParams.ParameterElements}
			{reportParams.AllParametersComplete && !loading && !report && <MessageBar messageBarType={MessageBarType.info}>No report data</MessageBar>}
			{!reportParams.AllParametersComplete && !loading && !report && <MessageBar messageBarType={MessageBarType.info}>Select required parameters to view the report</MessageBar>}
			{reportParams.AllParametersComplete && loading && <ProgressIndicator label="Loading report..." />}
			{reportParams.AllParametersComplete && !loading && report && report.length > 0 && (
				<DetailsList items={report} selectionMode={SelectionMode.none} layoutMode={DetailsListLayoutMode.justified} />
			)}
			{reportParams.AllParametersComplete && !loading && report && report.length === 0 && <MessageBar messageBarType={MessageBarType.info}>No records found</MessageBar>}
			{reportParams.AllParametersComplete && !loading && error && <MessageBar messageBarType={MessageBarType.error}>Error getting report</MessageBar>}
		</Stack>
	)
}
